 $(document).ready(  function(){

        // block数量
        let quantity = $(".slideTextProductInPicture-blockQuantity").text();

        // 复制第一份div到最后
        let firstDiv = $(".slideMoveDiv .slideDiv").eq(0).clone(true);
        // 修改id
        firstDiv.attr('id','slideDiv-' + (parseInt(quantity) + 1));
        // 添加到移动块中
        $(".slideMoveDiv").append(firstDiv);

        // 复制最后一份div到最前
        let lastOneDiv = $(".slideMoveDiv .slideDiv").eq(parseInt(quantity)-1).clone(true);
        // 修改id
        lastOneDiv.attr('id','slideDiv-' + 0);
        // 添加到移动块中
        $(".slideMoveDiv").prepend(lastOneDiv);

    });

    // 移动距离
    var moveDistance = 100;
    // 动画标志 false为已完成 true为动画中
    var animationFlag = false;
    // 下标
    var moveIndex = 1 ;
    // 图片数
    let pictureQuantity = $(".slideTextProductInPicture-blockQuantity").text();

    function productInPictureArrowClick(direction,event){

        event.preventDefault();

        // 动画结束后才能再次点击
        if (animationFlag){
            return;
        }

        animationFlag = true;
        // 判断移动方向进行移动
        if (direction == 'left'){
            moveIndex--;
            $(".slideMoveDiv").animate({left:"+="+moveDistance +"vw"},600,function (){
                if (moveIndex == 0){

                    let last = parseInt(pictureQuantity) * 100 * -1;
                    $(".slideMoveDiv").css('left',last + 'vw');
                    moveIndex = pictureQuantity;
                }
                animationFlag = false;
            });

        }else {
            moveIndex++;
            $(".slideMoveDiv").animate({left:"-="+moveDistance +"vw"},600,function (){
                if (moveIndex == parseInt(pictureQuantity) + 1){
                    $(".slideMoveDiv").css('left','-100vw');
                    moveIndex = 1;
                }
                animationFlag = false;
            });
        }

        // 对所有导航项去掉选中状态
        $(".dot").each(function (){
            $(this).removeClass('currentDot');
        })
        let dotIndex = moveIndex;
        if (dotIndex == 0){
            dotIndex = parseInt(pictureQuantity);
        }

        if (dotIndex == parseInt(pictureQuantity) + 1){
            dotIndex = 1;
        }

        // 对指定导航项添加选中状态
        $("#dot-" + dotIndex).addClass('currentDot');
    }

    function navClick(clickIndex){
        // 当前选中的导航项的index
        let currentIndex = $(".currentDot").data("index");


        // 动画结束后才能再次点击
        if (animationFlag){
            return;
        }
        animationFlag = true;

        // 处理普通及特殊情况(第一到最后，最后到第一)移动
        // 第一到最后
        if (currentIndex == 1 && clickIndex == parseInt(pictureQuantity)){
            $(".slideMoveDiv").animate({left:"+="+moveDistance +"vw"},600,function (){
                $(".slideMoveDiv").css('left',(parseInt(pictureQuantity) * moveDistance * -1) + "vw");
                animationFlag = false;
            });
        }
        // 最后到第一
        else if (currentIndex == parseInt(pictureQuantity) && clickIndex == 1){
            $(".slideMoveDiv").animate({left:"-="+moveDistance +"vw"},600,function (){
                $(".slideMoveDiv").css('left','-100vw');
                animationFlag = false;
            });
        }else {
            // 移动块数
            let moveCount = clickIndex - currentIndex;
            // 进行移动
            $(".slideMoveDiv").stop().animate({left:"-="+ moveDistance * moveCount +"vw"},600,function (){
                animationFlag = false;
            });
        }

        // 对所有导航项去掉选中状态
        $(".dot").each(function (){
            $(this).removeClass('currentDot');
        })
        // 对指定导航项添加选中状态
        $("#dot-" + clickIndex).addClass('currentDot');
        // 更换index
        moveIndex = clickIndex;
    }